/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "./layout.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
      allImageSharp {
        nodes {
          fluid {
            src
          }
        }
      }
    }
  `)

  return (
    <>
      <meta property="og:image" content="https://luis-aguiar.meivcore.pt/static/c30e3ce10826c2e772911fe6d8d13a2d/58556/logo-preto.webp" itemprop="image" />
      <div
        
      >
        <main>{children}</main>
     
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
